// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__JnKWZ","alertIcon":"ConfirmModal_alertIcon__1kXf8"};